<template>
  <el-tabs v-model="tabPaneVal" type="border-card" @tab-click="handleClick">
    <el-tab-pane label="待运输" name="WaitTransport">
      <waitTransport
        v-if="tabPaneVal == 'WaitTransport'"
        ref="WaitTransportRef"
        :is-allow-load-or-unload="isAllowLoadOrUnload"
        :type="1"
      />
    </el-tab-pane>
    <el-tab-pane label="运输中" name="InTransit">
      <inTransit
        v-if="tabPaneVal == 'InTransit'"
        ref="InTransitRef"
        :type="2"
        :is-allow-load-or-unload="isAllowLoadOrUnload"
        :order-detail-operate-allow-captain-dispatch-in-transit="
          orderDetailOperate_allowCaptainDispatchInTransit
        "
      />
    </el-tab-pane>
    <el-tab-pane label="已到达" name="UnLoaded">
      <unLoaded v-if="tabPaneVal == 'UnLoaded'" ref="UnLoadedRef" :type="3" />
    </el-tab-pane>
    <el-tab-pane label="已取消" name="deleted">
      <deleted v-if="tabPaneVal == 'deleted'" ref="deletedRef" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import deleted from "./components/deleted.vue";
import waitTransport from "./components/waitTransport.vue";
import inTransit from "./components/inTransit.vue";
import unLoaded from "./components/unLoaded.vue";
export default {
  name: "WaybillManage",
  components: {
    waitTransport,
    inTransit,
    unLoaded,
    deleted
  },
  data() {
    return {
      tabPaneVal: "WaitTransport",
      isAllowLoadOrUnload: "0",
      orderDetailOperate_allowCaptainDispatchInTransit: "0"
    };
  },
  created() {
    this.isAllowLoadOrUnload = JSON.parse(localStorage.getItem("dataBranch"))
      .partyGroupConfigCacheMap.orderDetailOperate_loadOrUnloadInBackground
      ? JSON.parse(localStorage.getItem("dataBranch")).partyGroupConfigCacheMap
          .orderDetailOperate_loadOrUnloadInBackground.configValue
      : "0";
    this.orderDetailOperate_allowCaptainDispatchInTransit = JSON.parse(
      localStorage.getItem("dataBranch")
    ).partyGroupConfigCacheMap.orderDetailOperate_allowCaptainDispatchInTransit
      ? JSON.parse(localStorage.getItem("dataBranch")).partyGroupConfigCacheMap
          .orderDetailOperate_allowCaptainDispatchInTransit.configValue
      : "0";
  },
  methods: {
    handleClick(tab, event) {
      this.tabPaneVal = tab.name;
    }
  }
};
</script>
